import axios from 'axios';

const api = axios.create({
  baseURL:
    'https://data.fixer.io/api/latest?access_key=b65789d4b1fee0c4cb1497ad3799e747&format=1',
});

export default api;
